import { render, staticRenderFns } from "./SetLogicDialog.vue?vue&type=template&id=3a58a2aa&scoped=true"
import script from "./SetLogicDialog.vue?vue&type=script&lang=js"
export * from "./SetLogicDialog.vue?vue&type=script&lang=js"
import style0 from "./SetLogicDialog.vue?vue&type=style&index=0&id=3a58a2aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a58a2aa",
  null
  
)

export default component.exports